import { TripTypeEnum } from '../../types/enums/trip/trip-type.enum'
import { TripStepTypeEnum } from '../../types/enums/trip-bookings/trip-step-type.enum'
import { TripDateFilter } from '../../types/models/trip-booking/trip-date'

export const transformTripDatesFilterToUrl = (filters?: TripDateFilter): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.date !== undefined && filters.date !== null)
    searchParams.append('date', filters.date)

  if (filters.isCompleted !== undefined)
    searchParams.append('isCompleted', filters.isCompleted ? 'true' : 'false')

  if (filters.tripIds !== undefined) searchParams.append('tripIds', filters.tripIds.join(','))

  if (filters.directionality !== undefined)
    searchParams.append('directionality', filters.directionality)

  if (filters.numberOfPlacesReserved !== undefined)
    searchParams.append('numberOfPlacesReserved', filters.numberOfPlacesReserved.join(','))

  if (filters.numberOfPlacesRequested !== undefined)
    searchParams.append('numberOfPlacesRequested', filters.numberOfPlacesRequested.join(','))

  if (filters.reservationIds !== undefined)
    searchParams.append('reservationIds', filters.reservationIds.join(','))

  if (filters.lecResponsableId !== undefined)
    searchParams.append('lecResponsableId', filters.lecResponsableId.toString())

  if (filters.remainingStudentPlaces !== undefined)
    searchParams.append('remainingStudentPlaces', String(filters.remainingStudentPlaces))

  if (filters.remainingStaffPlaces !== undefined)
    searchParams.append('remainingStaffPlaces', String(filters.remainingStaffPlaces))

  if (filters.tripType !== undefined) searchParams.append('tripType', filters.tripType)

  if (filters.includesReservation !== undefined)
    searchParams.append('includesReservation', String(filters.includesReservation))

  if (filters.includesAllocations !== undefined)
    searchParams.append('includesAllocations', String(filters.includesAllocations))

  if (filters.isFullyDispatched !== undefined)
    searchParams.append('isFullyDispatched', String(filters.isFullyDispatched))

  return searchParams.toString()
}

export const transformUrlToTripDatesFilter = (searchParams: URLSearchParams): TripDateFilter => {
  const filters: TripDateFilter = {}

  const date = searchParams.get('date')
  if (date) filters.date = date

  const isCompleted = searchParams.get('isCompleted')
  if (isCompleted) filters.isCompleted = isCompleted === 'true'

  const tripIds = searchParams.get('tripIds')
  if (tripIds) filters.tripIds = tripIds.split(',').map((id) => parseInt(id, 10))

  const directionality = searchParams.get('directionality')
  if (directionality) filters.directionality = directionality as TripStepTypeEnum

  const numberOfPlacesReserved = searchParams.get('numberOfPlacesReserved')
  if (numberOfPlacesReserved)
    filters.numberOfPlacesReserved = numberOfPlacesReserved
      .split(',')
      .map((id) => parseInt(id, 10))

  const numberOfPlacesRequested = searchParams.get('numberOfPlacesRequested')
  if (numberOfPlacesRequested)
    filters.numberOfPlacesRequested = numberOfPlacesRequested
      .split(',')
      .map((id) => parseInt(id, 10))

  const reservationIds = searchParams.get('reservationIds')
  if (reservationIds)
    filters.reservationIds = reservationIds.split(',').map((id) => parseInt(id, 10))

  const lecResponsableId = searchParams.get('lecResponsableId')
  if (lecResponsableId) filters.lecResponsableId = parseInt(lecResponsableId, 10)

  const remainingStudentPlaces = searchParams.get('remainingStudentPlaces')
  if (remainingStudentPlaces) filters.remainingStudentPlaces = remainingStudentPlaces === 'true'

  const remainingStaffPlaces = searchParams.get('remainingStaffPlaces')
  if (remainingStaffPlaces) filters.remainingStaffPlaces = remainingStaffPlaces === 'true'

  const tripType = searchParams.get('tripType')
  if (tripType) filters.tripType = tripType as TripTypeEnum

  const includesReservation = searchParams.get('includesReservation')
  if (includesReservation) filters.includesReservation = includesReservation === 'true'

  const includesAllocations = searchParams.get('includesAllocations')
  if (includesAllocations) filters.includesAllocations = includesAllocations === 'true'

  const isFullyDispatched = searchParams.get('isFullyDispatched')
  if (isFullyDispatched) filters.isFullyDispatched = isFullyDispatched === 'true'

  return filters
}
